import React, { useContext } from 'react';
import ResearchContactHeader from './ResearchContactHeader';
import NavigationMobile from '../navigation/NavigationMobile';
import { BaseContext } from '../contexts/baseContext';
import Contact from '../contactSection/Contact';

function ResearchContactInterface({ discussions, interfaceType }) {
  const { contactBodyHeight } = useContext(BaseContext);

  const sortContactTable = (contactTable) => {
    return contactTable.sort((contact1, contact2) => {
      return contact1.nom.toString().localeCompare(contact2.nom.toString());
    })
  }

  let contacts = [];

  discussions.forEach(discussion => {
    contacts.push(discussion.contact);
  })

  contacts = sortContactTable(contacts);

  return (
    <>
      <ResearchContactHeader />

      <div className="section-contacts-body" style={{ height: `${contactBodyHeight}px` }}>
      {
        interfaceType === "searchContact" ? (
          contacts.map(contact => {
            return (
              <Contact
                contact={contact}
                message={undefined}
                key={contact.id}
              />
            )
          })
        ):(
          null
        )
      }
      </div>

      <NavigationMobile />
    </>
  );
}

export default ResearchContactInterface;
